// 画面ごとのスタイルシート。
// React版は画面ごとにページ全体を再読み込みしていたため、各画面のCSSはその画面を表示している間だけ有効だった。
// Vue版は再読み込みせずに遷移するので、同じ状態を保つために表示中の画面のCSSだけを<style>として差し込む。
// 読み込み順はReact版のproductionビルドに合わせている（全画面共通のCSSは main.ts で読み込む）。
import homeCss from "./home.scss?inline"
import tutorialCss from "./tutorial.scss?inline"
import legacyLayoutCss from "./layout.css?inline"
import clockCss from "./clock.scss?inline"

export type PageStyleSet = "home" | "result" | "measurement"

const pageStyleSets: Record<PageStyleSet, readonly string[]> = {
    home: [homeCss, tutorialCss, legacyLayoutCss],
    result: [tutorialCss, legacyLayoutCss],
    measurement: [clockCss],
}

const ATTRIBUTE = "data-page-style"
let currentSet: PageStyleSet | null = null

export const applyPageStyles = (set: PageStyleSet | undefined) => {
    const next = set ?? null
    if (next === currentSet) return

    document.head.querySelectorAll(`style[${ATTRIBUTE}]`).forEach((element) => element.remove())

    if (next !== null) {
        for (const css of pageStyleSets[next]) {
            const element = document.createElement("style")
            element.setAttribute(ATTRIBUTE, next)
            element.textContent = css
            document.head.appendChild(element)
        }
    }
    currentSet = next
}
